import React from 'react';
import { Truck, Users, Package, Utensils } from 'lucide-react';
import { overhead, transport, personnel } from '../data/mock';

const ServicesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Kompletní servis
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Vše potřebné pro hladký průběh vaší akce
            </p>
          </div>
          
          {/* Overhead - Equipment & Trucks */}
          <div className="mb-16">
            <div className="flex items-center space-x-3 mb-8">
              <Package className="w-8 h-8 text-cyan-600" />
              <h3 className="text-3xl font-bold text-gray-900">
                Kompletní režie
              </h3>
            </div>
            <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-3xl p-8 border-2 border-cyan-200">
              <div className="text-center mb-6">
                <div className="text-5xl font-bold text-cyan-600 mb-2">
                  50 000 Kč
                </div>
                <div className="text-lg text-gray-700 font-medium">
                  Celková režie na 1000 osob
                </div>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6 mt-8">
                <div className="bg-white rounded-xl p-6 shadow-md">
                  <h4 className="font-bold text-gray-900 mb-4">Vybavení a technika</h4>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>Jednorázové obaly a příbory</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>Cateringové vybavení (chafingy, ohřívače, kávovary, výčep)</span>
                    </li>
                  </ul>
                </div>
                
                <div className="bg-white rounded-xl p-6 shadow-md">
                  <h4 className="font-bold text-gray-900 mb-4">Mobilní jednotky</h4>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>2x Food truck - mobilní kuchyně</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>2x Beer truck - výčepní vozy</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>1x Bar truck XXL</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>2x Live cooking stanoviště</span>
                    </li>
                  </ul>
                </div>
                
                <div className="bg-white rounded-xl p-6 shadow-md md:col-span-2">
                  <h4 className="font-bold text-gray-900 mb-4">Kompletní doprava</h4>
                  <ul className="grid md:grid-cols-2 gap-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>Doprava cateringu a potravin</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>Doprava personálu</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>Doprava všech Food trucků</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-cyan-600 mr-2">✓</span>
                      <span>Doprava Beer trucků a Bar trucku</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          {/* Personnel */}
          <div>
            <div className="flex items-center space-x-3 mb-8">
              <Users className="w-8 h-8 text-cyan-600" />
              <h3 className="text-3xl font-bold text-gray-900">
                Profesionální personál
              </h3>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-3xl p-8 border border-gray-200">
              <div className="text-center mb-6">
                <div className="text-5xl font-bold text-gray-900 mb-2">
                  36 700 Kč
                </div>
                <div className="text-lg text-gray-700 font-medium">
                  Odhadovaná cena personálu na 1000 osob (10 hodin)
                </div>
              </div>
              
              <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-6">
                <p className="text-sm text-amber-800 font-medium">
                  ⚠️ Personál je účtován dle skutečně odpracovaných hodin na místě realizace, započítáváme přípravy, průběh akce a úklid na místě konání.
                </p>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6">
                {personnel[0].breakdown.map((person, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-xl p-6 shadow-md border border-gray-100"
                  >
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <h4 className="text-lg font-bold text-gray-900">
                          {person.role}
                        </h4>
                      </div>
                      <div className="bg-cyan-100 text-cyan-700 px-3 py-1 rounded-full text-sm font-bold">
                        {person.count}x
                      </div>
                    </div>
                    <div className="border-t border-gray-200 pt-4 mt-4">
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-sm text-gray-600">Hodinová sazba:</span>
                        <span className="text-lg font-bold text-gray-900">
                          {person.hourlyRate} Kč/hod
                        </span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-600">Odhad hodin:</span>
                        <span className="text-sm font-semibold text-gray-700">
                          ~{person.hours} hod
                        </span>
                      </div>
                      <div className="flex justify-between items-center mt-2 pt-2 border-t border-gray-200">
                        <span className="text-sm text-gray-600">Subtotal:</span>
                        <span className="text-lg font-bold text-cyan-600">
                          {(person.count * person.hourlyRate * person.hours).toLocaleString('cs-CZ')} Kč
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
